import type { SmsIntegration } from '@chukua/common';

/** The line under a provider's name: its sender and when a test text last went out. */
export function smsIntegrationFacts(integration: SmsIntegration): string[] {
  const sender = integration.config['senderId'];
  const facts = [typeof sender === 'string' && sender !== '' ? `Sender ${sender}` : 'Shared sender'];
  facts.push(
    integration.lastTestedAt
      ? `Last test ${new Date(integration.lastTestedAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}`
      : 'Never tested',
  );
  return facts;
}
